var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"absolute","top":"50%","left":"50%"}},[_c('i',{staticClass:"fa fa-3x fa-cog fa-spin"})])])}]

export { render, staticRenderFns }